import { NavLink } from "react-router-dom";
import { CV_NAV } from "./cvContent";

// Lokalna nawigacja kontekstowa działu CV (nie dubluje globalnego menu Promptivo).
export const CvLocalNav = ({ active }) => {
  return (
    <nav
      data-testid="cv-local-nav"
      className="mb-8 flex gap-1 overflow-x-auto border-b border-brand-line pb-px"
      aria-label="Nawigacja działu CV i kariera"
    >
      {CV_NAV.map((item) => {
        const isActive = active === item.key;
        return (
          <NavLink
            key={item.key}
            to={item.to}
            data-testid={`cv-nav-${item.key}`}
            className={`whitespace-nowrap rounded-t-field px-4 py-2.5 text-sm font-medium transition-colors ${
              isActive
                ? "border-b-2 border-brand-accent text-brand-text"
                : "border-b-2 border-transparent text-brand-sec hover:text-brand-text"
            }`}
          >
            {item.label}
          </NavLink>
        );
      })}
    </nav>
  );
};
